module.exports = __webpack_public_path__ + "static/media/lamparita.ae490ecf.png";